export default __webpack_public_path__ + "static/media/tappetbox.811cdce6.png";